import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import ExpandableHtml from "../../user_content/expandable_html";
import CommunityRating from "../../community_rating";
import ReviewMetaDetails from "./review_meta_details";
import Spoiler from "../../user_content/spoiler";

export default GrComponentFactory.createClass({
  displayName: "ReviewDetails",

  propTypes: {
    readText: React.PropTypes.string,
    rating: React.PropTypes.number,
    user: GrPropTypes.user().isRequired,
    reviewUrl: React.PropTypes.string.isRequired,
    reviewBody: React.PropTypes.shape(GrPropTypes.truncatedHtml()),
    reviewSpoilerFlag: React.PropTypes.bool,
  },

  renderReadText() {
    return (
      this.props.readText ?
      <div className="gr-newsfeedItem__readCountText">
        {this.props.readText}
      </div>
        : null
    );
  },

  renderRating() {
    return (
      this.props.rating > 0 ?
        <span className="u-marginRightTiny">
          <span>Rating </span>
            <CommunityRating
              className="u-inlineBlock"
              rating={this.props.rating}
              size={CommunityRating.ICON_SIZES.MEDIUM}/>
        </span>
        : null
    );
  },

  renderReviewLink() {
    return (
      <a href={this.props.reviewUrl} className="gr-hyperlink">
        Read {this.props.user.viewableName}’s review
      </a>
    );
  },

  renderSpoilerWarning() {
    return (
      <span className="gr-newsfeedItem__reviewText__spoilerWarning">
        This review contains spoilers…
      </span>
    );
  },

  renderReviewBody() {
    const reviewBody = <ExpandableHtml {...this.props.reviewBody} />;
    if (this.props.reviewSpoilerFlag) {
      return (
        <Spoiler spoilerWarning={this.renderSpoilerWarning()}>
          {reviewBody}
        </Spoiler>
      );
    } else {
      return reviewBody;
    }
  },

  render() {
    return (
      <div>
        {this.renderReadText()}
        <div className="gr-metaText u-marginBottomXSmall">
          {this.renderRating()}
          {this.renderReviewLink()}
        </div>
        <ReviewMetaDetails {...this.props} />
        <div className="gr-newsfeedItem__reviewText">
          {this.renderReviewBody()}
        </div>
      </div>
    );
  },
});
